import Yup from '../../../yup-extended';

export default Yup.object({
  pin: Yup.string()
    .length(4, 'PIN must be 4 digits')
    .required('Please enter a PIN'),
  name: Yup.string().required('Please enter a name'),
  password: Yup.string().required('Please enter a password'),
  themeId: Yup.number().nullable().required('Please select a theme'),
  emailAddress: Yup.array().emailList(),
  visitorTypes: Yup.array().of(
    Yup.object().shape({
      visitorTypeId: Yup.number()
        .nullable()
        .required('Please select a visitor type'),
    }),
  ),
});
